module.exports = __webpack_public_path__ + "img/logo.ef916311.png";